var map = {
	"./icons/copy.svg": "8aac",
	"./icons/input-btn/down.svg": "7d55",
	"./icons/input-btn/search.svg": "9c6d",
	"./icons/network-select/arrow.svg": "f2ea",
	"./icons/network-select/bsc-selected.svg": "3c0a",
	"./icons/network-select/bsc.svg": "60b9",
	"./icons/network-select/eth-selected.svg": "3c06",
	"./icons/network-select/eth.svg": "56b2",
	"./icons/network-select/polygon-selected.svg": "3c85",
	"./icons/network-select/polygon.svg": "3272",
	"./icons/swap-btn/plus.svg": "0fc1",
	"./icons/swap-btn/refresh.svg": "8acb",
	"./icons/swap-btn/settings.svg": "0127",
	"./icons/token-input/add.svg": "12f0",
	"./icons/token-input/coins.svg": "57ea",
	"./icons/token-input/info.svg": "f970",
	"./icons/token-input/warning.svg": "f088"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36e7";